import { apiSlice } from '@/api';
import { PartnerPaymentStatus, Payment } from './types';

export const paymentsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPayments: builder.query<Payment[], { page: number; size: number }>({
      query: ({ page, size }) => ({
        url: `v1/payment/all?page=${page}&size=${size}`,
        method: 'GET',
      }),
      transformResponse: (response: { result: Payment[] }) => response.result,
    }),
    getPaymentsPartner: builder.query<
      Payment[],
      { page: number; size: number; status?: PartnerPaymentStatus }
    >({
      query: ({ page, size }) => ({
        url: `v1/payment/partner/all?page=${page}&size=${size}`,
        method: 'GET',
      }),
      transformResponse: (response: { result: Payment[] }) => response.result,
    }),
    getPaymentsPartnerTotalSum: builder.query<
      { amount: number; bonus: number },
      void
    >({
      query: () => ({
        url: `v1/payment/partner/total`,
        method: 'GET',
      }),
      transformResponse: (response: {
        result: { amount: number; bonus: number };
      }) => response.result,
    }),
  }),
});

export const {
  useGetPaymentsQuery,
  useGetPaymentsPartnerQuery,
  useGetPaymentsPartnerTotalSumQuery,
} = paymentsApi;
